import App from '../app'
import init from '@lib/init/web'

init('page_redirect', App)
